export const getSystemState = state => state.system;
export const getPersistentQueryParamState = state => getSystemState(state).persistentQueryParams;
